const NivelList = () => import("~/components/Views/Prova/Nivel/List");
const NivelNew = () => import("~/components/Views/Prova/Nivel/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Classificação", link: "" }
];

export const nivel = [
  {
    path: "classificacao/nivel",
    component: NivelList,
    name: "Nível",
    meta: {
      title: "Nível",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "classificacao/nivel/new",
    component: NivelNew,
    name: "Novo Nível",
    meta: {
      title: "Novo Nível",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "classificacao/nivel/:id",
    component: NivelNew,
    name: "Alterar Nível",
    meta: {
      title: "Alterar Nível",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/classificacao/nivel.js